import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
import { finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { FormGeneratorDialogComponent } from '@app/shared/components/form-generator-dialog/form-generator-dialog.component';
import { EmployeeProfilePhotoService } from '@app/modules/talent-track/talent-track-edit-employee/edit-employee/components/employee-details/components/upload-profile-image/services/employee-profile-photo.service';


@Component({
  selector: 'app-photo-and-details',
  templateUrl: './photo-and-details.component.html',
  styleUrls: ['./photo-and-details.component.scss']
})
export class PhotoAndDetailsComponent implements OnInit {
  user$: any;
  dialogRef: any;
  refresh = false;
  isLoading: boolean;

  constructor(
    private dialog: MatDialog,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
    private oidcAuthService: OidcAuthService,
    private imageService: EmployeeProfilePhotoService,
  ) {
  }

  ngOnInit(): void {
    this.user$ = this.oidcAuthService.userProfile;
  }

  openFormDialog() {
    let formData = {
      profileImage: null
    };

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      formId: `frm_LjvqGflGvsvbpP`,
      formData: formData,
    };

    this.dialogRef = this.dialog.open(FormGeneratorDialogComponent, dialogConfig);

    const sub = this.dialogRef.componentInstance.emitFormData.subscribe((event) => {
      this.upload(event.profilePicture);
      sub.unsubscribe();
    });
  }

  //return a promise that resolves with a File instance
  urltoFile(url, filename, mimeType){
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){return new File([buf], filename,{type:mimeType});})
    );
  }

  upload(file: File) {
    this.overlayService.show();
    
    this.imageService.uploadProfilePhoto(file, this.user$.userId)
      .pipe(
        finalize(() => this.overlayService.hide())
      )
      .subscribe(
        () => {
          this.snackbarService.openSnackBar(this.translate.instant('SavedSuccessfully'), 'clear', 'success');
        }
      );
  }

  refreshData() {
    this.refresh = true;

    setTimeout(() => {
      this.refresh = false;
    }, 100);
  }

}